// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import mbrEntity from './entities/mbr.json';
import mbrMenu from '../pages/mbr/menu.json';
import mbrFullForm from '../pages/mbr/forms/full.json';
import mbrContextForm from '../pages/mbr/forms/context.json';
import mbrMiniForm from '../pages/mbr/forms/mini.json';
import mbrLookupForm from '../pages/mbr/forms/lookup.json';
import mbrTableView from '../pages/mbr/views/table.json';
import mbrStagesView from '../pages/mbr/views/stages.json';
import mbrCardsView from '../pages/mbr/views/cards.json';
import mbrInlineView from '../pages/mbr/views/inline.json';
import mbrBacklogView from '../pages/mbr/views/backlog.json';
import mbrSplitView from '../pages/mbr/views/split.json';
import mbrCalendarView from '../pages/mbr/views/calendar.json';
import mbrDashboardView from '../pages/mbr/views/dashboard.json';

/** Тип запису «Депутат» зі сторінками пакета: меню, форми та подання з pages/mbr/. */
export const mbrDefinition: IRecordTypeDefinition = {
  ...mbrEntity,
  views: assembleViewSet({
      table: mbrTableView,
      stages: mbrStagesView,
      cards: mbrCardsView,
      inline: mbrInlineView,
      backlog: mbrBacklogView,
      split: mbrSplitView,
      calendar: mbrCalendarView,
      dashboard: mbrDashboardView,
  }),
  form: mbrFullForm,
  forms: { full: mbrFullForm, context: mbrContextForm, mini: mbrMiniForm, lookup: mbrLookupForm },
  menu: mbrMenu,
} as IRecordTypeDefinition;
